import { useCallback, useEffect, useState } from 'react';
import { ENVS, envByKey, keepSignedIn, whoAmI, type AdminMe } from './lib/api';
import { useStored, useTheme } from './lib/store';
import { SignIn } from './screens/SignIn';
import { DRAWER_ROUTES, SCREEN_COMPONENTS } from './screens';
import { Shell, type AdminCtx } from './ui/Shell';

keepSignedIn();

export default function App() {
  const [theme, setTheme] = useTheme();
  const [envKey, setEnvKey] = useStored<string>('vs.admin.env', ENVS[0].key);
  const env = envByKey(envKey);
  const [me, setMe] = useState<AdminMe | null>(null);
  const [reason, setReason] = useState<string | undefined>();
  const [checked, setChecked] = useState(false);

  const check = useCallback(async () => {
    const r = await whoAmI(env);
    setMe(r.me);
    setReason(r.reason);
    setChecked(true);
  }, [env]);
  useEffect(() => { setChecked(false); void check(); }, [check]);

  if (!checked) return <div className="login" style={{ color: 'var(--ink-45)' }}>Checking {env.label}…</div>;
  if (!me) return <SignIn env={env} envs={ENVS} setEnv={setEnvKey} dark={theme === 'dark'} reason={reason} onSignedIn={() => void check()} />;

  return (
    <Shell env={env} setEnv={setEnvKey} drawerRoutes={DRAWER_ROUTES} me={me} theme={theme} setTheme={setTheme} signedOut={() => { setMe(null); setReason('signed out'); }}>
      {(ctx: AdminCtx) => {
        const S = SCREEN_COMPONENTS[ctx.screen] ?? SCREEN_COMPONENTS.overview;
        return <S key={`${ctx.env.key}:${ctx.screen}`} />;
      }}
    </Shell>
  );
}
